import axios from "axios"
import qs from "qs"

import type { Authentication } from "@/lib/authentication"

export const fetchPatient: Authentication.Functions.FetchPatient = async ({
  auth_token,
  uid,
}) => {
  try {
    const response = await axios.get<{
      patient: Authentication.Patient | undefined
    }>(`/api/get-patient`, {
      params: { auth_token },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: `brackets` })
      },
    })

    if (response.status === 200 && response.data.patient) {
      return {
        ...response.data.patient,
        uid,
      }
    }

    if (response.status === 204) {
      return
    }
  } catch (error) {
    console.log(`fetchPatient error`, error)
  }
}
